import React from 'react';

import { DateText } from '../../../components/DateText/DateText';
import { Tooltip } from '../../../components/Tooltip/Tooltip';
import { DateFormat } from '../../../types/DateFormat';

interface Props {
  /** JS Date */
  datetime?: Date;
  /** Date format */
  format?: DateFormat;
  /** Tooltip text */
  tooltip?: string;
}

export const DatetimeCell = ({ datetime, format, tooltip }: Props) => {
  return (
    <Tooltip tooltip={tooltip}>
      <DateText date={datetime} format={format} />
    </Tooltip>
  );
};
